"use strict";

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ChevronDown = _interopRequireDefault(require("@quintoandar/cozy-icons/ChevronDown"));
var _Typography = _interopRequireDefault(require("../../Typography"));
var _Dropdown = _interopRequireDefault(require("../../Dropdown"));
var Styles = _interopRequireWildcard(require("./NavItem.styles"));
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) {
    if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
      var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
      i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
  }
  return n["default"] = e, t && t.set(e, n), n;
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var NavItemDropdown = function NavItemDropdown(_ref) {
  var children = _ref.children,
    subItems = _ref.subItems;
  return /*#__PURE__*/_react["default"].createElement(_Dropdown["default"], {
    triggerComponent: /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        display: 'flex',
        alignItems: 'center'
      }
    }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], null, children), /*#__PURE__*/_react["default"].createElement(_ChevronDown["default"], {
      fontSize: "small"
    })),
    tabIndex: 0
  }, subItems());
};
var NavItem = /*#__PURE__*/_react["default"].forwardRef(function (_ref2, ref) {
  var children = _ref2.children,
    Icon = _ref2.icon,
    highlight = _ref2.highlight,
    subItems = _ref2.subItems,
    href = _ref2.href,
    target = _ref2.target;
  if (typeof children === 'string') {
    if (!href && !subItems) {
      throw new Error('You must provide a href when using a NavItem without any children component and without subitems');
    }
    return /*#__PURE__*/_react["default"].createElement(Styles.NavItem, {
      ref: ref,
      highlight: highlight,
      role: "menuitem"
    }, Icon && /*#__PURE__*/_react["default"].createElement(Icon, null), subItems ? /*#__PURE__*/_react["default"].createElement(NavItemDropdown, {
      subItems: subItems
    }, children) : /*#__PURE__*/_react["default"].createElement("a", {
      tabIndex: 0,
      href: href,
      target: target
    }, children));
  }
  return /*#__PURE__*/_react["default"].createElement(Styles.NavItemWrapper, {
    ref: ref,
    tabIndex: -1
  }, children);
});
NavItemDropdown.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes["default"].node,
  subItems: _propTypes["default"].func
} : {};
NavItem.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes["default"].node,
  icon: _propTypes["default"].elementType,
  highlight: _propTypes["default"].bool,
  subItems: _propTypes["default"].func,
  href: _propTypes["default"].string,
  target: _propTypes["default"].string
} : {};
var _default = exports["default"] = NavItem;